import Repository from "../Repository";

const resource = "/adspecials";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getAdSpecial(adSpecialId){
        return Repository.get(`${resource}/${adSpecialId}`);
    },
    createAdSpecial(json){
        return Repository.post(`${resource}`,json);
    },
    updateAdSpecial(adSpecialId,json){
        return Repository.put(`${resource}/${adSpecialId}`,json);
    },
    deleteAdSpecial(adSpecialId){
        return Repository.delete(`${resource}/${adSpecialId}`);
    }
}